import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import i18n from "@/i18n";
import { TemplateData } from "../../data/templateData";
import { TemplatesStore } from "../../store/modules/templates";
import { parseDate } from "../../utilities/parseHelper";
import ITemplatesService from "../../services/templates/ITemplatesService";
import { DiTokens } from "../../services/diTokens";
import { container } from "@/inversify.config";

export class TemplatesVue extends Vue {
  get templatesService(): ITemplatesService {
    return container.get<ITemplatesService>(DiTokens.TemplatesService);
  }

  /** Стор профиля */
  get templatesStore(): TemplatesStore {
    return getModule(TemplatesStore, this.$store);
  }

  get storeLoading(): boolean {
    return this.templatesStore.templatesLoading;
  }

  get simpleTemplates(): Array<TemplateData> {
    return this.templatesStore.simpleTemplates;
  }

  get periodTemplates(): Array<TemplateData> {
    return this.templatesStore.periodTemplates;
  }

  /**Ограничение по количеству показываемых шаблонов */
  get temlatesShow(): Array<TemplateData> {
    if (this.simpleTemplates.length > 4) return this.simpleTemplates.slice(0, 3);
    return this.simpleTemplates;
  }

  tempatesActiveHref: string = "simple";

  editMode: boolean = false;

  selectedTemplate: TemplateData = new TemplateData();

  deleteMode: boolean = false;

  loading: boolean = false;

  @Watch("deleteMode", { immediate: true })
  deleteModeChange(value: boolean) {
    if (!value) {
      this.selectedTemplate = new TemplateData();
    }
  }

  toTemplate(template: TemplateData): void {
    if (template.IsActive) {
      this.$router.push("operation/1/" + template.Id);
    }
  }

  editTemplate(temp: TemplateData): void {
    this.editMode = true;
    this.selectedTemplate = temp;
  }

  async deleteTemplate(temp: TemplateData): Promise<void> {
    this.deleteMode = true;
    this.selectedTemplate = temp;
  }

  async deleteTemplateHandler(): Promise<void> {
    this.loading = true;
    try {
      await this.templatesService.deleteTemplate(this.selectedTemplate.Id);
      await this.templatesStore.fetchTemplates();
      Vue.$toast.open({
        message: i18n.t("main.templates.successDelete").toString(),
        type: "success"
      });
    } catch (e) {
      Vue.$toast.open({
        message: e.message,
        type: "error"
      });
    }
    this.cencelDelete();
    this.loading = false;
  }

  cencelDelete(): void {
    this.deleteMode = false;
  }

  displayTemplatePeriod(template: TemplateData): string {
    return `${this.$options.filters.date(parseDate(template.NextDate), 'datetime')} (${this.getPeriodText(
      template.Period
    )})`;
  }

  getPeriodText(nPeriod: number): string {
    let sPeriod: string = "";
    switch (nPeriod) {
      case 1:
        sPeriod = i18n.t("main.templates.periodDaily").toString();
        break;
      case 2:
        sPeriod = i18n.t("main.templates.periodWeek").toString();
        break;
      case 3:
        sPeriod = i18n.t("main.templates.periodMonth").toString();
        break;
      default:
        sPeriod = "";
    }
    return sPeriod;
  }
}
